import React from 'react';
import { StyledCounterBadge, StyledRedCounterBadge } from './CounterBadge.styled';
export var CounterBadge = createCounterBadge(StyledCounterBadge);
export var RedCounterBadge = createCounterBadge(StyledRedCounterBadge);
function createCounterBadge(StyledCounterBadgeType) {
  return function (props) {
    if (!props.children) {
      if (props.emptyContent === null || props.emptyContent === undefined) {
        return /*#__PURE__*/React.createElement("span", null);
      }
      return /*#__PURE__*/React.createElement(StyledCounterBadgeType, {
        isEmpty: true
      }, props.emptyContent);
    }
    return /*#__PURE__*/React.createElement(StyledCounterBadgeType, null, props.children);
  };
}